/**************************************************
 * Nombre:       Portada_Home
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import {Splide, SplideSlide} from "@splidejs/react-splide";
import '@splidejs/splide/dist/css/splide-core.min.css';
import {useEffect, useState} from "react";
import {obtenerColWheres} from "../../../Servicios/BD/obtenerColWheres";
import {where} from "firebase/firestore";
import Banner_Portada_Home from "../SubComponentes/Banner_Portada_Home";
import {useResponsive} from "../../../Modulo_Responsive/Hooks/useResponsive";


const Portada_Home = () => {
    const {sCell} = useResponsive()
    const [anuncios, setAnuncios] = useState([])

    useEffect(() => {
        let w = [where('estado', '==', 'Publicado')]
        obtenerColWheres({col: 'anuncios', wheres: w}).then((dox) => {
            console.log(dox)
            if (dox.res) {
                setAnuncios(dox.data)
            }
        })
    }, []);
    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            spacing={2}
        >


            <Grid container size={{xs: 12, sm: 12, md: 12}}>
                <Splide aria-label="My Favorite Images"
                        options={{
                            arrows: false,
                            pagination: false,
                            autoplay: true,
                            interval: 8000,
                            width: '100%',
                            gap: 10
                        }}>
                    {anuncios.map((item, index) => (
                        <SplideSlide key={`as${index}`}>
                            <Banner_Portada_Home item={item}/>
                        </SplideSlide>
                    ))}
                </Splide>
            </Grid>


        </Grid>
    )
}
export default Portada_Home

